import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch, useAppSelector } from 'store';
import {
  loadCurrentResidentsItem,
  saveCurrentResidentsItem,
  saveCurrentResidentsItemDraft,
} from 'store/slices/currentResidents/actions';
import { CurrentResidentsItem } from 'store/slices/currentResidents/interfaces';
import { StatusesEnum } from 'constants/status';
import { DeepPartial } from 'types/utils';

import { Form } from './components/Form';
import { mapValuesToForm } from './components/Form/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { item } = useAppSelector(state => state.currentResidents);
  const isCorrectItem = item?.id === Number(id);

  React.useEffect(() => {
    dispatch(loadCurrentResidentsItem(id));
  }, [id]);

  const onSubmit = (values: CurrentResidentsItem) => {
    setIsLoading(true);
    const newItem = { ...values, id: item?.id };
    dispatch(saveCurrentResidentsItem(newItem))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Действующий резидент успешно обновлен',
        });
        navigate('/currentResidents');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<CurrentResidentsItem>) => {
    setIsLoading(true);
    dispatch(saveCurrentResidentsItemDraft({ ...values, id: item?.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Действующий резидент успешно создан',
        });
        navigate('/currentResidents');
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {isCorrectItem && (
        <Form
          onSubmit={onSubmit}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          defaultValues={mapValuesToForm(item)}
          onSaveAsDraft={onSaveAsDraft}
        />
      )}
    </MainLayout>
  );
};
